import { Injectable } from '@angular/core';
import { LoadingController } from '@ionic/angular/standalone';
import { TranslateService } from '@ngx-translate/core';

@Injectable({
  providedIn: 'root',
})
export class LoadingService {

  private loading: HTMLIonLoadingElement | null = null;

  constructor(
    private loadingCtrl: LoadingController,
    private translate: TranslateService,
  ) { }

  public async showLoading(duration?: number) {
    if (this.loading == null) {
      console.info('Showing loading');
      return this.loadingCtrl.create({
        spinner: 'circles',
        duration,
        message: this.translate.instant('general.pleaseWait'),
        keyboardClose: false,
        translucent: true,
      }).then((loading) => {
        this.loading = loading;
        this.loading.present();
        console.info('Loading visible');
      });
    }
  }

  public async hideLoading() {
    console.info('Hiding loading');
    return this.loading?.dismiss().then(() => {
      console.info('Loading hid');
      this.loading = null;
    });
  }
}
